import { notifications } from '../notifications-service';
import { getErrorMessages, isSilentError } from './api-error';

/**
 * Global API error handler: shows the error messages as toast notifications.
 */
export function apiErrorHandler(err: unknown) {
  if (isSilentError(err)) {
    return;
  }

  getErrorMessages(err).forEach((message) => notifications.error(message));
}
